import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuItem from '@mui/material/MenuItem'
import { useTranslation } from 'react-i18next'
import MenuList from '@mui/material/MenuList'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { ReactElement } from 'react'

interface PRMActionButtonsProps {
  handleMenuItemClick: (arg0: any) => void
  options: string[]
  handleToggle: () => void
  anchorRef: any
  open: boolean
  label: string
  handleClose: (event: Event) => void
  buttonGroupId: string
  optionIcons: ReactElement[]
  page: string
}

export const PRMActionButtons = ({
  handleMenuItemClick,
  options,
  handleToggle,
  anchorRef,
  open,
  label,
  handleClose,
  buttonGroupId,
  optionIcons,
  page,
}: PRMActionButtonsProps) => {
  const { t } = useTranslation()
  const popperStyleExpandedWidth = {
    zIndex: 1,
  }
  const popperStyleExactWidth = {
    zIndex: 1,
    width: anchorRef.current?.clientWidth,
  }

  const getStyle = () => {
    return page === 'PRMGrid' ? popperStyleExactWidth : popperStyleExpandedWidth
  }

  const getOptionLabel = (option: string) => {
    return page === 'PRMGrid'
      ? t(`participant.inviteAdmin.${option}Option`)
      : t(`participant.PRMActionButtons.participantDetails.options.${option}`)
  }

  return (
    <>
      <ButtonGroup
        ref={anchorRef}
        aria-label={label}
        size="large"
        variant="outlined"
        data-testid={buttonGroupId}
      >
        <Button onClick={handleToggle}>{label}</Button>
        <Button
          size="small"
          aria-label={label}
          aria-haspopup="menu"
          onClick={handleToggle}
          data-testid={'arrow-dropdown-button'}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={getStyle()}
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placement="bottom-start"
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option: string, index: number) => (
                    <MenuItem
                      key={option}
                      onClick={() => handleMenuItemClick(option)}
                    >
                      {optionIcons.length > 0 && <>{optionIcons[index]}</>}
                      {getOptionLabel(option)}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
}

export default PRMActionButtons
